import React, { Component, createRef } from 'react';

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
} from "reactstrap";
import "toastr/build/toastr.min.css";
import { Form, Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
    ErrorModal,
    MessageBoxModal,
    RavenAgTable,
    DeleteModal,
    FileUploader,
    WarningModal
} from "components/Common/CombinedComponents";
import RavenFormikField from "components/Common/RavenFormikField";
import PageModalFooter from "components/Common/PageComponents/PageModalFooter";
import {
    getTitleValue,
    getInitValue,
    getInitValueBoolean,
    getDateTime,
    getInitValueTriple,
} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

import {
    getMerchantSubMerchantId,
    getMerchantPermission,
    getProductTypeDefList,
    getLinkPaymentStatusDefList,
    getCurrencyListSync,
    getMerchantLinkPayment,
    getMerchantLinkPaymentByGuid,
    addMerchantLinkPayment,
    updateMerchantLinkPayment,
    updateMerchantLinkPaymentStatus,
    shareMerchantLinkPayment,
    merchantLinkPaymentError,
    merchantPermissionApiError
} from "../../store/actions";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LinkPaymentShare from './LinkPaymentShare';
import defaultLinkProductImage from "assets/images/icons/link-payment-icon.svg";

function productImageSrcFromBase64(productImageBase64, defaultSrc) {
    if (productImageBase64 == null || String(productImageBase64).trim() === "") {
        return defaultSrc;
    }
    const s = String(productImageBase64).trim();
    if (s.startsWith("data:")) {
        return s;
    }
    return `data:image/png;base64,${s}`;
}
const linkPaymentStatus = {
    WaitingForApproval: "1",
    Approved: "2",
    MerchantClosedForSale: "3",
    PayFacClosedForSale: "4",
    SharedWithCustomer: "5",
    LinkUsed: "6"
};
class LinkPaymentList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recordList: [],
            modal: false,
            record: "",
            addAnother: false,
            isAdd: false,
            isEdit: false,
            isDetail: false,
            isEditedValue: false,
            updateRecord: "",
            deleteModal: false,
            deleteRecord: "",
            installmentInfoEnabled: false,
            merchantNameEnabled: false,
            merchantAddressEnabled: false,
            messageBoxModal: false,
            errorModal: false,
            error: undefined,
            merchantPermissionError: undefined,
            merchantPermissionModal: false,
            linkPaymentShareModal: false,
            base64FileImage: "",
            productImageBase64: "",
            merchantId: "",
            isApproved: false,
            fetchModalKind: null,
            pendingRow: null,
            recordcolumns: [
                {
                    headerName: this.props.t("merchantId"),
                    field: "merchantId",
                },
                {
                    headerName: this.props.t("productName"),
                    field: "productName",
                },
                {
                    headerName: this.props.t("productPrice"),
                    field: "productPrice",
                },
                {
                    headerName: this.props.t("linkUrl"),
                    field: "linkUrl",
                },
                {
                    headerName: this.props.t("productTypeGuid"),
                    field: "productTypeGuid",
                    valueFormatter: params => this.getProductTypeGuid(params.value),
                    filterParams: {
                        valueFormatter: params =>
                            this.getProductTypeGuid(params.value),
                    },
                },
                {
                    headerName: this.props.t("linkPaymentStatusName"),
                    field: "linkPaymentStatusGuid",
                    valueFormatter: params => this.getLinkPaymentStatusGuid(params.value),
                    filterParams: {
                        valueFormatter: params =>
                            this.getLinkPaymentStatusGuid(params.value),
                    },
                },
                {
                    headerName: this.props.t("updateDateTime"),
                    field: "updateDateTime",
                    filter: "agDateTimeColumnFilter",
                    cellRenderer: "dateTimeCellRender",
                    filterParams: { valueFormatter: getDateTime },
                },
            ]

        };
        this.toggle = this.toggle.bind(this);
        this.handleValidRecordSubmit = this.handleValidRecordSubmit.bind(this);
        this.handleAddRecordClick = this.handleAddRecordClick.bind(this);
        this.handleEditRecordClick = this.handleEditRecordClick.bind(this);
        this.handleDetailClick = this.handleDetailClick.bind(this);
        this.formSubmitButtonRef = createRef();
        this.shareToggle = this.shareToggle.bind(this);
    }

    componentDidMount() {
        this.props.apiError("");
        const {
            onGetMerchantLinkPayment,
            onGetMerchantPermission,
            onGetMerchantSubMerchantId,
            onGetProductTypeDefList,
            onGetCurrencyList,
            onGetLinkPaymentStatusDefList,
            merchantId
        } = this.props;

        onGetMerchantPermission({ userName: localStorage.getItem("username") });
        onGetMerchantLinkPayment({ userName: localStorage.getItem("username") });
        onGetMerchantSubMerchantId({ userName: localStorage.getItem("username") });
        onGetCurrencyList();
        onGetProductTypeDefList();
        onGetLinkPaymentStatusDefList();

        this.setState({ merchantId: merchantId });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            error,
            recordList,
            waitingRecordListUpdate,
            merchantPermissionError,
            recordMerchantPermission,
            merchantId,
            linkPaymentByGuidLoading,
            linkPaymentDetailRecord,
        } = this.props;

        if (
            prevProps.linkPaymentByGuidLoading === true &&
            linkPaymentByGuidLoading === false &&
            this.state.fetchModalKind &&
            this.state.pendingRow
        ) {
            const { fetchModalKind, pendingRow } = this.state;
            let merged = { ...pendingRow };
            if (linkPaymentDetailRecord && typeof linkPaymentDetailRecord === "object") {
                merged = { ...pendingRow, ...linkPaymentDetailRecord };
            }
            const base64FileImage = productImageSrcFromBase64(
                merged.productImageBase64,
                defaultLinkProductImage,
            );
            const productImageBase64Val =
                merged.productImageBase64 != null ? merged.productImageBase64 : "";

            if (fetchModalKind === "detail") {
                this.setState(
                    {
                        record: merged,
                        addAnother: false,
                        isDetail: true,
                        isEdit: true,
                        isAdd: false,
                        isApproved: true,
                        merchantNameEnabled: merged.merchantNameEnabled,
                        merchantAddressEnabled: merged.merchantAddressEnabled,
                        installmentInfoEnabled: merged.installmentInfoEnabled,
                        base64FileImage,
                        productImageBase64: productImageBase64Val,
                        fetchModalKind: null,
                        pendingRow: null,
                    },
                    () => this.toggle(),
                );
            } else if (fetchModalKind === "edit") {
                this.setState(
                    {
                        record: merged,
                        addAnother: false,
                        isDetail:
                            pendingRow.linkPaymentStatusGuid !=
                            linkPaymentStatus.WaitingForApproval
                                ? true
                                : false,
                        isEdit:
                            pendingRow.linkPaymentStatusGuid !=
                            linkPaymentStatus.WaitingForApproval
                                ? true
                                : false,
                        isApproved:
                            pendingRow.linkPaymentStatusGuid ==
                                linkPaymentStatus.PayFacClosedForSale ||
                            pendingRow.linkPaymentStatusGuid == linkPaymentStatus.LinkUsed
                                ? true
                                : false,
                        isAdd: false,
                        merchantNameEnabled: merged.merchantNameEnabled,
                        merchantAddressEnabled: merged.merchantAddressEnabled,
                        installmentInfoEnabled: merged.installmentInfoEnabled,
                        base64FileImage,
                        productImageBase64: productImageBase64Val,
                        fetchModalKind: null,
                        pendingRow: null,
                    },
                    () => this.toggle(),
                );
            }
        }

        if (prevProps.error !== error) {
            this.setState({ error: error });
            this.setState({ errorModal: true });
        }
        if (prevProps.merchantId !== merchantId) {
            this.setState({ merchantId: merchantId });
        }
        if (prevProps.recordList !== recordList) {
            this.setState({ recordList: recordList });
        }
        if (prevProps.merchantPermissionError !== merchantPermissionError) {
            this.setState({ error: merchantPermissionError });
        }

        if (prevProps.recordMerchantPermission !== recordMerchantPermission) {
            this.setState({ recordMerchantPermission: recordMerchantPermission });
            if (recordMerchantPermission.linkPaymentEnabled == false) {
                this.setState({ merchantPermissionModal: true });
            }
        }
        if (prevProps.waitingRecordListUpdate !== waitingRecordListUpdate) {
            this.setState({ messageBoxModal: true });
        }

    }
    getProductTypeGuid(guid) {
        let array = this.props.recordProductTypeList
            .filter(i => i.guid === guid)
            .map(x => x);

        if (array?.length) return array[0].description;
        else return guid;
    }

    getLinkPaymentStatusGuid(guid) {
        let array = this.props.recordLinkPaymentStatusList
            .filter(i => i.guid === guid)
            .map(x => x);

        if (array?.length) return array[0].description;
        else return guid;
    }

    handleAddRecordClick = () => {
        const { merchantId } = this.state;
        this.setState({
            record: "",
            merchantId: merchantId,
            merchantNameEnabled: false,
            merchantAddressEnabled:false,
            installmentInfoEnabled: false,
            isEdit: false,
            isAdd: true,
            base64FileImage: null,
            isApproved: false,

        });
        this.toggle();
    };

    handleDetailClick = values => {
        this.setState({ fetchModalKind: "detail", pendingRow: values });
        this.props.onGetMerchantLinkPaymentByGuid(values.guid);
    };

    handleEditRecordClick = values => {
        this.setState({ fetchModalKind: "edit", pendingRow: values });
        this.props.onGetMerchantLinkPaymentByGuid(values.guid);
    };

    handleValidRecordSubmit = (values, actions) => {

        const { productImageBase64, merchantId } = this.state;
        const { onAddMerchantLinkPayment, onUpdateMerchantLinkPayment } = this.props;

        values.merchantNameEnabled = this.state.merchantNameEnabled;
        values.merchantAddressEnabled = this.state.merchantAddressEnabled;
        values.installmentInfoEnabled = this.state.installmentInfoEnabled;
        if (values.guid != "") {
            if (productImageBase64 != "") {
                values.productImageBase64 = productImageBase64;
            }
            onUpdateMerchantLinkPayment(values);
        }
        else {
            values.productImageBase64 = productImageBase64;
            values.merchantId = merchantId;
            onAddMerchantLinkPayment({
                merchantId: String(values.merchantId),
                productName: values.productName,
                productDescription: values.productDescription,
                productImageBase64: values.productImageBase64,
                productTypeGuid: values.productTypeGuid,
                productPrice: values.productPrice,
                currencyGuid: values.currencyGuid,
                stock: values.stock,
                merchantNameEnabled: values.merchantNameEnabled,
                merchantAddressEnabled:values.merchantAddressEnabled,
                installmentInfoEnabled: values.installmentInfoEnabled,
                linkDescription: values.linkDescription
            });
        }
        this.toggle();
    };


    toggle() {
        this.setState(prevState => ({ modal: !prevState.modal }));

        if (this.state.modal) {
            setTimeout(() => this.setState({ isDetail: false, isEdit: false }), 150);
        }
    }

    onChangeMerchantNameEnabledRadioButton = (e, data) => {
        this.setState({ merchantNameEnabled: e });
    }

    onChangeMerchantAddressEnabledRadioButton = (e, data) => {
        this.setState({ merchantAddressEnabled: e });
    }
    
    onChangeInstallmentInfoEnabledRadioButton = (e, data) => {
        this.setState({ installmentInfoEnabled: e });
    }

    onFileChangeImage = (file) => {
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                this.setState({ productImageBase64: reader.result.split(',')[1] });
            };
            reader.readAsDataURL(file);
        }
    };

    onFileClickImage = () => {
    };

    handleDeleteRecordClick = record => {
        const deleteGuid = record.guid;
        const deleteRecord = {
            productName: record.productName,
            linkUrl: record.linkUrl,
        };
        this.setState({ record: deleteRecord, deleteGuid });
        this.setState({ deleteModal: true });
    };

    handleModalDeleteClick = e => {
        e.preventDefault();
        const { onUpdateMerchantLinkPaymentStatus } = this.props;
        const { deleteGuid } = this.state;

        if (deleteGuid !== undefined) {
            onUpdateMerchantLinkPaymentStatus(deleteGuid);
            this.setState({ deleteModal: false });
        }
    };

    handleSharePaymentLinkClick = record => {

        if (record.linkPaymentStatusGuid == linkPaymentStatus.PayFacClosedForSale || record.linkPaymentStatusGuid == linkPaymentStatus.MerchantClosedForSale || record.linkPaymentStatusGuid == linkPaymentStatus.WaitingForApproval) {
            this.setState({ warningModal: true, warningMessage: this.props.t("warningMessageLinkStatus") });

        }
        else {
            const recordGuid = record.guid;
            this.setState({ record: record, recordGuid });
            this.setState({ linkPaymentShareModal: true });
        }
    };

    formOnSubmitMiddleware = values => {
        const { onShareMerchantLinkPayment } = this.props;
        onShareMerchantLinkPayment(values);
        this.shareToggle();
    };

    shareToggle() {
        this.setState(prevState => ({ linkPaymentShareModal: !prevState.linkPaymentShareModal, isOpen: false }));
    }

    render() {
        const { recordList } = this.props;

        const {
            record,
            error,
            deleteModal,
            merchantNameEnabled,
            merchantAddressEnabled,
            installmentInfoEnabled,
            merchantPermissionModal,
            messageBoxModal,
            linkPaymentShareModal,
            isApproved,
            warningModal,
            warningMessage
        } = this.state;

        const styles = {
            border: "2px solid rgba(0, 0, 0, 0.08)",
        };

        return (
            <React.Fragment>
                {error && (
                    <ErrorModal
                        errorMessage={error}
                        onCloseModalClick={() => this.setState({ error: undefined })}
                    />
                )}
                <ToastContainer />
                {deleteModal && (<DeleteModal
                    record={record}
                    show={deleteModal}
                    onDeleteClick={this.handleModalDeleteClick}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />)}
                <LinkPaymentShare
                    record={record}
                    show={linkPaymentShareModal}
                    formSubmitButtonRef={this.formSubmitButtonRef}
                    formOnSubmitMiddleware={this.formOnSubmitMiddleware}
                    onCloseClick={() => this.setState({ linkPaymentShareModal: false })}
                />
                <WarningModal
                    warningMessage={warningMessage}
                    show={warningModal}
                    onCloseClick={() => this.setState({ warningModal: false })}
                />
                <MessageBoxModal
                    messageText={this.props.t("linkPaymentSuccessfully")}
                    messageDetailText={
                        this.props.t("linkPaymentDetailSuccessfully")
                    }
                    show={messageBoxModal}
                    onCloseClick={() => this.setState({ messageBoxModal: false })}
                />

                <div className="page-content">
                    <Container fluid>
                        {merchantPermissionModal ?

                            (<Row>
                                <Col
                                    lg={18}
                                    style={{
                                        textAlign: "center",
                                    }}
                                >
                                    <div>
                                        {" "}
                                        <i
                                            className="bx bx-info-circle"
                                            style={{
                                                marginTop: "15px",
                                                fontSize: "3.5em",
                                                color: "orange",
                                            }}
                                        />
                                        <h4>{this.props.t("merchantPermissionMessage")}</h4>
                                    </div>
                                    <div className="modal-body">
                                        <p>{this.props.t("merchantPermissionDetailMessage")}</p>
                                    </div>
                                </Col>
                            </Row>) : (
                                <Row>
                                    <Col xs="12">
                                        <Card>
                                            <CardBody>
                                                <RavenAgTable
                                                    onAddClick={this.handleAddRecordClick}
                                                    onEditClick={this.handleEditRecordClick}
                                                    onDetailClick={this.handleDetailClick}
                                                    onDeleteClick={this.handleDeleteRecordClick}
                                                    onDynamicFunction={this.handleSharePaymentLinkClick}
                                                    dynamicFunctionName={this.props.t("sharePaymentLink")}
                                                    dynamicFunctionIcon={"mdi mdi-monitor-share font-size-16 text-primary me-1"}
                                                    actionItems={true}
                                                    breadCrumbTitle={this.props.t("getPaid")}
                                                    breadCrumbItem={this.props.t("linkPaymentList")}
                                                    exportOption={false}
                                                    recordcolumns={this.state.recordcolumns}
                                                    recordList={recordList}
                                                />
                                                <Modal
                                                    isOpen={this.state.modal}
                                                    className={this.props.className}
                                                    onClose={() => this.toggle()}
                                                    size="lg"
                                                    backdrop={"static"}
                                                    id="staticBackdrop"
                                                >
                                                    <ModalHeader toggle={this.toggle} tag="h4">
                                                        {getTitleValue(this, "linkPayment")}
                                                    </ModalHeader>
                                                    <ModalBody>
                                                        <Formik
                                                            enableReinitialize={true}
                                                            initialValues={{
                                                                guid: getInitValue(
                                                                    record,
                                                                    record.guid,
                                                                ),
                                                                productTypeGuid: getInitValue(
                                                                    record,
                                                                    record.productTypeGuid,
                                                                ),
                                                                currencyGuid: getInitValue(
                                                                    record,
                                                                    record.currencyGuid,
                                                                ),
                                                                merchantId: getInitValue(
                                                                    record,
                                                                    record.merchantId,
                                                                ) || this.state.merchantId,
                                                                productName: getInitValue(
                                                                    record,
                                                                    record.productName,
                                                                ),
                                                                productPrice: getInitValue(
                                                                    record,
                                                                    record.productPrice,
                                                                ),
                                                                productDescription: getInitValue(
                                                                    record,
                                                                    record.productDescription,
                                                                ),
                                                                linkDescription: getInitValue(
                                                                    record,
                                                                    record.linkDescription,
                                                                ),
                                                                merchantNameEnabled: getInitValueBoolean(
                                                                    record,
                                                                    record.merchantNameEnabled,
                                                                ),
                                                                merchantAddressEnabled: getInitValueBoolean(
                                                                    record,
                                                                    record.merchantAddressEnabled,
                                                                ),
                                                                installmentInfoEnabled: getInitValueBoolean(
                                                                    record,
                                                                    record.installmentInfoEnabled,
                                                                ),
                                                                stock: getInitValue(
                                                                    record,
                                                                    record.stock,
                                                                ),
                                                                remaingStock: getInitValue(
                                                                    record,
                                                                    record.remaingStock,
                                                                ),
                                                                productImageBase64: getInitValue(
                                                                    record,
                                                                    record.productImageBase64,
                                                                ),
                                                                linkUrl: getInitValue(
                                                                    record,
                                                                    record.linkUrl,
                                                                ),
                                                                linkPaymentStatusName: getInitValueTriple(
                                                                    record,
                                                                    record.linkPaymentStatus,
                                                                    record.linkPaymentStatus?.description,
                                                                ),
                                                            }}
                                                            validationSchema={Yup.object().shape({
                                                                merchantId: Yup.string().required(this.props.t("mustBe")),
                                                                currencyGuid: Yup.string().required(this.props.t("mustBe")),
                                                                productTypeGuid: Yup.string().required(this.props.t("mustBe")),
                                                                stock: Yup.string().required(this.props.t("mustBe")),
                                                                productName: Yup.string().strict(true).trim(this.props.t("spaceCaseError"))
                                                                    .required(this.props.t("mustBe"))
                                                                    .max(140, this.props.t("maxLengthError").format(50)),
                                                                productDescription: Yup.string().strict(true).trim(this.props.t("spaceCaseError"))
                                                                    .max(140, this.props.t("maxLengthError").format(250)),
                                                                linkDescription: Yup.string().strict(true).trim(this.props.t("spaceCaseError"))
                                                                    .max(140, this.props.t("maxLengthError").format(250)),
                                                                productPrice: Yup.string()
                                                                    .matches(/^\d+(?:\.\d+)?$/, this.props.t("invalidFormat"))
                                                                    .required(this.props.t("mustBe"))
                                                                    .max(21, this.props.t("maxLengthError").format(21))
                                                                    .test('is-decimal', 'Only "." can be used between numbers.', value => {
                                                                        return !isNaN(parseInt(value));
                                                                    }),
                                                                productTypeGuid: Yup.number().test(
                                                                    "oneOfRequired",
                                                                    this.props.t("mustBe"),
                                                                    function (item) {
                                                                        return (
                                                                            this.parent.productTypeGuid !==
                                                                            undefined
                                                                        );
                                                                    },
                                                                ),
                                                                currencyGuid: Yup.number().test(
                                                                    "oneOfRequired",
                                                                    this.props.t("mustBe"),
                                                                    function (item) {
                                                                        return (
                                                                            this.parent.currencyGuid !==
                                                                            undefined
                                                                        );
                                                                    },

                                                                ),
                                                            })}
                                                            onSubmit={values => {
                                                                this.handleValidRecordSubmit(values);
                                                            }}
                                                        >
                                                            {({
                                                                errors,
                                                                status,
                                                                touched,
                                                                values,
                                                                setFieldValue,
                                                                dirty
                                                            }) => (
                                                                <Form onChange={dirty => {
                                                                    this.setState({ isEditedValue: dirty });
                                                                }}>
                                                                    <fieldset disabled={this.state.isDetail}>
                                                                        <Row>
                                                                            <Col xl={12}>
                                                                                <Card>
                                                                                    <Card style={styles}>
                                                                                        <CardHeader>
                                                                                            {this.props.t("merchantInfo")}
                                                                                        </CardHeader>
                                                                                        <CardBody>
                                                                                            <Row>
                                                                                                <Col lg={12} className="col-12">
                                                                                                    <RavenFormikField
                                                                                                        errors={errors}
                                                                                                        touched={touched}
                                                                                                        name={"merchantId"}
                                                                                                        label={"merchantId"}
                                                                                                        type="text"
                                                                                                        disabled={true}
                                                                                                    />
                                                                                                </Col>

                                                                                            </Row>
                                                                                        </CardBody>

                                                                                    </Card>
                                                                                    {this.state.isAdd === false && (<Card style={styles}>
                                                                                        <CardHeader>
                                                                                            {this.props.t("linkPaymentStatus")}
                                                                                        </CardHeader>
                                                                                        <CardBody>
                                                                                            <Row>
                                                                                                <Col lg={12} className="col-12">
                                                                                                    <RavenFormikField
                                                                                                        errors={errors}
                                                                                                        touched={touched}
                                                                                                        name={"linkUrl"}
                                                                                                        label={"linkUrl"}
                                                                                                        type="text"
                                                                                                        disabled={true}

                                                                                                    />

                                                                                                </Col>
                                                                                            </Row>
                                                                                            <Row>
                                                                                                <Col lg={6} className="col-6">
                                                                                                    <RavenFormikField
                                                                                                        errors={errors}
                                                                                                        touched={touched}
                                                                                                        name={"linkPaymentStatusName"}
                                                                                                        label={"linkPaymentStatusName"}
                                                                                                        type="text"
                                                                                                        disabled={true}

                                                                                                    />
                                                                                                </Col>
                                                                                                <Col lg={6} className="col-6">

                                                                                                    <RavenFormikField
                                                                                                        errors={errors}
                                                                                                        touched={touched}
                                                                                                        name={"linkPaymentStatusGuid"}
                                                                                                        label={"linkPaymentStatusGuid"}
                                                                                                        component="multiselect"
                                                                                                        type="singleselect"
                                                                                                        valueList={this.props.recordLinkPaymentStatusList.filter(i => i.merchantEnabled === true)}
                                                                                                        nameOnValueList={["description"]}
                                                                                                        disabled={this.state.isApproved}

                                                                                                    />
                                                                                                </Col>

                                                                                            </Row>
                                                                                        </CardBody>
                                                                                    </Card>)}


                                                                                    <Card style={styles} disabled={this.state.isDetail}>
                                                                                        <CardHeader>
                                                                                            {this.props.t("productInfo")}
                                                                                        </CardHeader>
                                                                                        <CardBody>
                                                                                            <Row>
                                                                                                <Col lg={7} className="col-7">
                                                                                                    <Row>
                                                                                                        <Col lg={12} className="col-12">
                                                                                                            <RavenFormikField
                                                                                                                errors={errors}
                                                                                                                touched={touched}
                                                                                                                name={"productName"}
                                                                                                                label={"productName"}
                                                                                                                type="text"
                                                                                                            />
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                    <Row>
                                                                                                        <Col lg={6} className="col-6">
                                                                                                            <RavenFormikField
                                                                                                                errors={errors}
                                                                                                                touched={touched}
                                                                                                                name={"productPrice"}
                                                                                                                label={"productPrice"}
                                                                                                                type="text"
                                                                                                            />
                                                                                                        </Col>
                                                                                                        <Col lg={6} className="col-6">
                                                                                                            <RavenFormikField
                                                                                                                errors={errors}
                                                                                                                touched={touched}
                                                                                                                name={"currencyGuid"}
                                                                                                                label={"currencyGuid"}
                                                                                                                component="multiselect"
                                                                                                                type="singleselect"
                                                                                                                valueList={this.props.recordCurrencyList}
                                                                                                                nameOnValueList={["alphabeticCode", "currencyName"]}
                                                                                                                disabled={this.state.isDetail}

                                                                                                            />
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                    <Row>
                                                                                                        <RavenFormikField
                                                                                                            errors={errors}
                                                                                                            touched={touched}
                                                                                                            name={"productTypeGuid"}
                                                                                                            label={"productTypeGuid"}
                                                                                                            component="multiselect"
                                                                                                            type="singleselect"
                                                                                                            valueList={this.props.recordProductTypeList}
                                                                                                            nameOnValueList={["description"]}
                                                                                                            disabled={this.state.isDetail}

                                                                                                        />
                                                                                                    </Row>
                                                                                                    <Row>
                                                                                                        <RavenFormikField
                                                                                                            errors={errors}
                                                                                                            touched={touched}
                                                                                                            name={"productDescription"}
                                                                                                            label={"productDescription"}
                                                                                                            type="textarea"
                                                                                                            rows={3}
                                                                                                        />
                                                                                                    </Row>
                                                                                                    <Row>
                                                                                                        <RavenFormikField
                                                                                                            errors={errors}
                                                                                                            touched={touched}
                                                                                                            name={"linkDescription"}
                                                                                                            label={"linkDescription"}
                                                                                                            type="textarea"
                                                                                                            rows={6}
                                                                                                        />
                                                                                                    </Row>
                                                                                                </Col>

                                                                                                <Col lg={2} className="col-2">

                                                                                                    <FileUploader initialFileName={!this.state.isDetail ? this.props.t("noSelectedFileImage") : ''} initialImage={this.state.base64FileImage} onChange={this.onFileChangeImage} onClick={this.onFileClickImage} noSelectedFile={this.props.t("noSelectedFileImage")} browseFilesToUpload={this.props.t("browseImageFilesToUpload")} imageDisabled={this.state.isDetail} />

                                                                                                    <Row style={{ marginTop: "15px" }}>
                                                                                                        <RavenFormikField
                                                                                                            errors={errors}
                                                                                                            touched={touched}
                                                                                                            name={"stock"}
                                                                                                            label={"stock"}
                                                                                                            type="text"
                                                                                                            disabled={this.state.isDetail}

                                                                                                        />
                                                                                                        {(this.state.isDetail || this.state.isEdit) && (<RavenFormikField
                                                                                                            errors={errors}
                                                                                                            touched={touched}
                                                                                                            name={"remaingStock"}
                                                                                                            label={"remaingStock"}
                                                                                                            type="text"
                                                                                                            disabled={true}

                                                                                                        />)}

                                                                                                    </Row>
                                                                                                    <Row>
                                                                                                        <RavenFormikField
                                                                                                            errors={errors}
                                                                                                            touched={touched}
                                                                                                            name={"merchantNameEnabled"}
                                                                                                            label={"merchantNameEnabled"}
                                                                                                            component="radiobutton"
                                                                                                            checked={merchantNameEnabled}
                                                                                                            onChange={e => {
                                                                                                                this.onChangeMerchantNameEnabledRadioButton(e, values);
                                                                                                            }}
                                                                                                            disabled={this.state.isDetail}
                                                                                                        />
                                                                                                    </Row>
                                                                                                    <Row>
                                                                                                        <RavenFormikField
                                                                                                            errors={errors}
                                                                                                            touched={touched}
                                                                                                            name={"merchantAddressEnabled"}
                                                                                                            label={"merchantAddressEnabled"}
                                                                                                            component="radiobutton"
                                                                                                            checked={merchantAddressEnabled}
                                                                                                            onChange={e => {
                                                                                                                this.onChangeMerchantAddressEnabledRadioButton(e, values);
                                                                                                            }}
                                                                                                            disabled={this.state.isDetail}
                                                                                                        />
                                                                                                    </Row>
                                                                                                    
                                                                                                    <Row>
                                                                                                        <RavenFormikField
                                                                                                            errors={errors}
                                                                                                            touched={touched}
                                                                                                            name={"installmentInfoEnabled"}
                                                                                                            label={"installmentInfoEnabled"}
                                                                                                            component="radiobutton"
                                                                                                            checked={installmentInfoEnabled}
                                                                                                            onChange={e => {
                                                                                                                this.onChangeInstallmentInfoEnabledRadioButton(e, values);
                                                                                                            }}
                                                                                                            disabled={this.state.isDetail}
                                                                                                        />
                                                                                                    </Row>

                                                                                                </Col>
                                                                                            </Row>

                                                                                        </CardBody>
                                                                                    </Card>
                                                                                </Card>
                                                                            </Col>
                                                                        </Row>
                                                                    </fieldset>
                                                                    <ModalHeader
                                                                        style={{
                                                                            marginTop: "-30px",
                                                                            marginBottom: "10px",
                                                                        }}
                                                                    ></ModalHeader>
                                                                    <PageModalFooter
                                                                        isEdit={!this.state.isAdd ? true : false}
                                                                        isDetail={!isApproved ? false : true}
                                                                        onCancelClick={() => this.toggle()}
                                                                        onCheckboxClick={() => {
                                                                            this.setState({
                                                                                addAnother: !this.state.addAnother,
                                                                            });
                                                                        }}
                                                                    />
                                                                </Form>
                                                            )}
                                                        </Formik>
                                                    </ModalBody>
                                                </Modal>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}
                    </Container>
                </div>


            </React.Fragment>
        );
    }
}

LinkPaymentList.propTypes = {
    t: PropTypes.any,
    error: PropTypes.any,
    className: PropTypes.any,
    merchantPermissionError: PropTypes.any,
    apiError: PropTypes.any,
    record: PropTypes.any,
    recordList: PropTypes.any,
    merchantId: PropTypes.any,
    recordCurrencyList: PropTypes.array,
    recordProductTypeList: PropTypes.array,
    recordLinkPaymentStatusList: PropTypes.array,
    recordMerchantPermission: PropTypes.any,
    recordMerchantLinkPaymentList: PropTypes.array,
    onGetCurrencyList: PropTypes.func,
    onGetProductTypeDefList: PropTypes.func,
    onGetLinkPaymentStatusDefList: PropTypes.func,
    onGetMerchantPermission: PropTypes.func,
    onAddMerchantLinkPayment: PropTypes.func,
    onUpdateMerchantLinkPayment: PropTypes.func,
    onGetMerchantSubMerchantId: PropTypes.func,
    onGetMerchantLinkPayment: PropTypes.func,
    onUpdateMerchantLinkPaymentStatus: PropTypes.func,
    onShareMerchantLinkPayment: PropTypes.func,
    onGetMerchantLinkPaymentByGuid: PropTypes.func,
    waitingRecordListUpdate: PropTypes.any,
    linkPaymentByGuidLoading: PropTypes.bool,
    linkPaymentDetailRecord: PropTypes.any,
};

const mapStateToProps = ({
    currencyDefinition,
    productTypeDef,
    merchantPermission,
    merchantLinkPayment,
    linkPaymentStatusDef
}) => ({
    recordList: merchantLinkPayment.recordList,
    recordCurrencyList: currencyDefinition.recordList,
    recordProductTypeList: productTypeDef.recordList,
    recordLinkPaymentStatusList: linkPaymentStatusDef.recordList,
    recordMerchantPermission: merchantPermission.record,
    merchantId: merchantPermission.subMerchantId,
    error: merchantLinkPayment.error,
    merchantPermissionError: merchantPermission.error,
    waitingRecordListUpdate: merchantLinkPayment.waitingRecordListUpdate,
    linkPaymentByGuidLoading: merchantLinkPayment.linkPaymentByGuidLoading,
    linkPaymentDetailRecord: merchantLinkPayment.linkPaymentDetailRecord,
});

const mapDispatchToProps = dispatch => ({
    onGetCurrencyList: () => dispatch(getCurrencyListSync()),
    onGetProductTypeDefList: () => dispatch(getProductTypeDefList()),
    onGetLinkPaymentStatusDefList: () => dispatch(getLinkPaymentStatusDefList()),
    onGetMerchantPermission: userName => dispatch(getMerchantPermission(userName)),
    onGetMerchantSubMerchantId: userName => dispatch(getMerchantSubMerchantId(userName)),
    onGetMerchantLinkPayment: userName => dispatch(getMerchantLinkPayment(userName)),
    onGetMerchantLinkPaymentByGuid: guid => dispatch(getMerchantLinkPaymentByGuid(guid)),
    onAddMerchantLinkPayment: record => dispatch(addMerchantLinkPayment(record)),
    onUpdateMerchantLinkPayment: record => dispatch(updateMerchantLinkPayment(record)),
    onUpdateMerchantLinkPaymentStatus: guid => dispatch(updateMerchantLinkPaymentStatus(guid)),
    onShareMerchantLinkPayment: record => dispatch(shareMerchantLinkPayment(record)),
    apiError: error => dispatch(merchantLinkPaymentError(error)),
    apiErrorMerchantPermission: merchantPermissionError => dispatch(merchantPermissionApiError(merchantPermissionError)),
});
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withTranslation()(LinkPaymentList));
